import { useState } from "react";
import api from "../api";
import { Modal } from "./ui";
import { notifyMailChanged } from "../composerWindow";

// Bozza WhatsApp: mostra sempre il messaggio a cui si risponde e permette di inviarlo da qui
export default function WaDraftModal({ draft, onClose, onSent }) {
  const [text, setText] = useState(draft.body_text || "");
  const [busy, setBusy] = useState("");
  const [msg, setMsg] = useState("");

  const save = async () => {
    setBusy("save"); setMsg("");
    try {
      await api.post("/emails/drafts", { ...draft, body_text: text, attachments: [] });
      notifyMailChanged();
      setMsg("Bozza aggiornata.");
    } catch (e) { setMsg(e.response?.data?.detail || "Salvataggio non riuscito"); }
    finally { setBusy(""); }
  };

  const send = async () => {
    if (!text.trim()) return;
    setBusy("send"); setMsg("");
    try {
      await api.post(`/whatsapp/send-draft/${draft.id}`, { body: text.trim() });
      notifyMailChanged();
      onSent && onSent();
      onClose();
    } catch (e) { setMsg(e.response?.data?.detail || "Invio non riuscito"); setBusy(""); }
  };

  const remove = async () => {
    if (!window.confirm("Elimino questa bozza WhatsApp?")) return;
    setBusy("del");
    try {
      await api.delete(`/emails/drafts/${draft.id}`);
      notifyMailChanged();
      onSent && onSent();
      onClose();
    } catch (e) { setMsg(e.response?.data?.detail || "Eliminazione non riuscita"); setBusy(""); }
  };

  return (
    <Modal title={`Bozza WhatsApp · ${draft.wa_name || draft.to}`} onClose={onClose}>
      <div data-testid="wa-draft-modal">
        <p className="muted" style={{ fontSize: 12.5, marginTop: 0 }}>Verrà inviato a <strong>{draft.to}</strong> dal numero dello studio.</p>

        {draft.quoted_text ? (
          <div className="wa-quoted" data-testid="wa-draft-quoted">
            <div className="muted" style={{ fontSize: 11.5, marginBottom: 4 }}>
              ↩︎ Rispondi a {draft.wa_name || draft.to}{draft.quoted_at ? ` · ${new Date(draft.quoted_at).toLocaleString("it-IT", { dateStyle: "short", timeStyle: "short" })}` : ""}
            </div>
            <div style={{ whiteSpace: "pre-wrap", fontSize: 13, maxHeight: 180, overflowY: "auto" }}>{draft.quoted_text}</div>
          </div>
        ) : (
          <p className="muted" style={{ fontSize: 12 }}>Nessun messaggio citato per questa bozza.</p>
        )}

        <textarea rows={6} value={text} onChange={(e) => setText(e.target.value)} style={{ width: "100%", marginTop: 10 }}
          placeholder="Scrivi la risposta WhatsApp…" data-testid="wa-draft-text" />
        {msg && <p className="muted" style={{ fontSize: 12.5 }} data-testid="wa-draft-msg">{msg}</p>}

        <div className="modal-actions" style={{ justifyContent: "space-between" }}>
          <button className="btn danger" onClick={remove} disabled={!!busy} data-testid="wa-draft-delete">🗑 Elimina bozza</button>
          <span style={{ display: "flex", gap: 8 }}>
            <a className="btn" href={`/whatsapp?phone=${encodeURIComponent(draft.to)}`} data-testid="wa-draft-open-chat">💬 Apri la chat</a>
            <button className="btn" onClick={save} disabled={!!busy} data-testid="wa-draft-save">{busy === "save" ? "…" : "💾 Salva"}</button>
            <button className="btn primary" onClick={send} disabled={!!busy || !text.trim()} data-testid="wa-draft-send">{busy === "send" ? "Invio…" : "➤ Invia su WhatsApp"}</button>
          </span>
        </div>
      </div>
    </Modal>
  );
}
